import { action, observable } from 'mobx';
import { EventManager } from 'choerodon-ui/dataset';
import { getMousePosition, transformZoomData } from '../util';
const KeyGen = (function* (id) {
    while (true) {
        yield `modal-${id}`;
        id += 1;
    }
})(1);
const containerInstances = observable.array();
const removeInstance = action((instance) => {
    const index = containerInstances.indexOf(instance);
    if (index > -1) {
        containerInstances.splice(index, 1);
    }
});
const addInstance = action((instance) => {
    removeInstance(instance);
    containerInstances.unshift(instance);
});
function getKey() {
    return KeyGen.next().value;
}
function clear(closeByLocationChange) {
    containerInstances.forEach((instance) => {
        instance.clear(closeByLocationChange);
    });
}
const mousePositionEventBound = new WeakSet();
function registerMousePosition() {
    const doc = typeof window === 'undefined' ? undefined : document;
    if (doc && !mousePositionEventBound.has(doc)) {
        // 只有点击事件支持从鼠标位置动画展开
        new EventManager(doc).addEventListener('click', (e) => {
            ModalManager.mousePosition = getMousePosition(transformZoomData(e.clientX), transformZoomData(e.clientY), window);
            // 100ms 内发生过点击事件，则从点击位置动画展示
            // 否则直接 zoom 展示
            // 这样可以兼容非点击方式展开
            setTimeout(() => (delete ModalManager.mousePosition), 100);
        }, true);
        mousePositionEventBound.add(doc);
    }
}
const ModalManager = {
    addInstance,
    removeInstance,
    getKey,
    mousePositionEventBound,
    containerInstances,
    clear,
    containerStyles: new WeakMap(),
    registerMousePosition,
};
export default ModalManager;
